import React from 'react';
import useWithStore from "@/Hooks/useWithStore";
import BaseLayout from "@/Layouts/BaseLayout";
import {Breadcrumbs} from '@mui/material';
import Link from "@/Layouts/Link";
import '@/Pages/PolzovatelskoeSoglashenie/scss/index.scss';


class PolzovatelskoeSoglashenie extends React.Component {
    render() {
        const {mobileApp = false} = this.props

        return <BaseLayout {...this.props}>
            <section className={`section`}>
                {!mobileApp && (
                    <div className={`breadcrumbs`}>
                        <div className="container">
                            <Breadcrumbs
                                maxItems={2}
                                itemsAfterCollapse={2}
                            >
                                <Link className="breadcrumbs__link" href={`/`}>
                                    Главная
                                </Link>
                                <p className="breadcrumbs__text">
                                    Пользовательское соглашение
                                </p>
                            </Breadcrumbs>
                        </div>
                    </div>
                )}
                <div className={`container`}>
                    <h1 className={`h1`}>Пользовательское соглашение</h1>
                    <div className={`polzovatelskoe-soglashenie`}>
                        <div className={`polzovatelskoe-soglashenie__section`}>
                            <p className={`polzovatelskoe-soglashenie__title`}>
                                1. Общие положения
                            </p>
                            <p className={`polzovatelskoe-soglashenie__item`}>
                                1.1. Настоящее Пользовательское Соглашение (далее&nbsp;&mdash; Соглашение) относится
                                к&nbsp;Сайту расположенному по&nbsp;адресу: platina-jewelry.ru и&nbsp;ко&nbsp;всем
                                соответствующим Сайтам, связанным с&nbsp;данным Сайтом.
                            </p>
                            <p className={`polzovatelskoe-soglashenie__item`}>
                                1.2. Сайт является собственностью Общества с&nbsp;ограниченной ответственностью
                                Ювелирный завод &laquo;Платина&raquo;, ИНН 4415004465, ОГРН 1044469011608,
                                адрес места нахождения: Костромская область, Красносельский район, поселок городского
                                типа Красное-на-Волге, улица Окружная, дом&nbsp;8.
                            </p>
                            <p className={`polzovatelskoe-soglashenie__item`}>
                                1.3. Настоящее Соглашение регулирует отношения между Администрацией Сайта
                                platina-jewelry.ru (далее&nbsp;&mdash; Администрация Сайта) и&nbsp;Пользователем
                                данного Сайта.
                            </p>
                            <p className={`polzovatelskoe-soglashenie__item`}>
                                1.4. Администрация сайта оставляет за&nbsp;собой право в&nbsp;любое время
                                изменять, добавлять или удалять пункты настоящего Соглашения без уведомления
                                Пользователя.
                            </p>
                            <p className={`polzovatelskoe-soglashenie__item`}>
                                1.5. Продолжение использования Сайта Пользователем означает принятие Соглашения
                                и&nbsp;изменений, внесенных в&nbsp;настоящее Соглашение.
                            </p>
                            <p className={`polzovatelskoe-soglashenie__item`}>
                                1.6. Пользователь несет персональную ответственность за&nbsp;проверку настоящего
                                Соглашения на&nbsp;наличие изменений в&nbsp;нем.
                            </p>
                        </div>
                        <div className={`polzovatelskoe-soglashenie__section`}>
                            <p className={`polzovatelskoe-soglashenie__title`}>
                                2. Термины и&nbsp;определения
                            </p>
                            <p className={`polzovatelskoe-soglashenie__item`}>
                                2.1. Перечисленные ниже термины имеют для целей настоящего Соглашения следующее
                                значение:
                            </p>
                            <p className={`polzovatelskoe-soglashenie__item`}>
                                2.1.1. сайт&nbsp;&mdash; совокупность логически связанных между собой веб-страниц,
                                а&nbsp;также место расположения контента сервера и&nbsp;представляет собой массив
                                связанных данных, имеющий уникальный адрес и&nbsp;воспринимаемый Пользователем как
                                единое целое и&nbsp;осуществляющий свою деятельность посредством Интернет-ресурса
                                и&nbsp;сопутствующих ему сервисов;
                            </p>
                            <p className={`polzovatelskoe-soglashenie__item`}>
                                2.1.2. сайт, содержащий информацию о&nbsp;компании-владельце (собственнике),
                                партнерах компании, товарах и&nbsp;продавцах, позволяет осуществить выбор,
                                заказ&nbsp;и (или) приобретение товаров;
                            </p>
                            <p className={`polzovatelskoe-soglashenie__item`}>
                                2.1.3. администрация Сайта&nbsp;&mdash; уполномоченные сотрудники на&nbsp;управления
                                Сайтом, действующие от&nbsp;имени Компании;
                            </p>
                            <p className={`polzovatelskoe-soglashenie__item`}>
                                2.1.4. пользователь Сайта (далее Пользователь)&nbsp;&mdash; лицо, имеющее доступ
                                к&nbsp;Сайту посредством сети Интернет и&nbsp;использующее Сайт;
                            </p>
                            <p className={`polzovatelskoe-soglashenie__item`}>
                                2.1.5. содержание Сайта (далее&nbsp;&mdash; Содержание)&nbsp;&mdash; охраняемые
                                результаты интеллектуальной деятельности, включая тексты литературных произведений,
                                их&nbsp;названия, предисловия, аннотации, статьи, иллюстрации, дизайны, обложки,
                                музыкальные произведения с&nbsp;текстом или без текста, графические, текстовые,
                                фотографические, производные, составные и&nbsp;иные произведения, Пользовательские
                                интерфейсы, визуальные интерфейсы, названия товарных знаков, логотипы, коммерческие
                                обозначения, фирменные наименования, программы для эвм, базы данных, а&nbsp;также
                                дизайн, структура, выбор, координация, внешний вид, общий стиль и&nbsp;расположение
                                данного Содержания, входящего в&nbsp;состав Сайта и&nbsp;другие объекты
                                интеллектуальной собственности все вместе и/или по&nbsp;отдельности, содержащиеся
                                на&nbsp;Сайте.
                            </p>
                            <p className={`polzovatelskoe-soglashenie__item`}>
                                2.1.6. верификация&nbsp;&mdash; процедура, позволяющая установить реальность
                                и&nbsp;принадлежность определённого номера телефона конкретному физическому лицу,
                                в&nbsp;результате которой Пользователю присваивается определенный&nbsp;ID, создаётся
                                Личный кабинет, привязанный к&nbsp;верифицированному номеру телефона, а&nbsp;также
                                предоставляется возможность авторизоваться в&nbsp;Личном кабинете.
                            </p>
                        </div>
                        <div className={`polzovatelskoe-soglashenie__section`}>
                            <p className={`polzovatelskoe-soglashenie__title`}>
                                3. Предмет соглашения
                            </p>
                            <p className={`polzovatelskoe-soglashenie__item`}>
                                3.1. Предметом настоящего Соглашения является предоставление Пользователю
                                доступа к&nbsp;содержащемуся на&nbsp;Сайте контенту.
                            </p>
                            <p className={`polzovatelskoe-soglashenie__item`}>
                                3.2. Сайт предоставляет Пользователю следующие виды услуг (сервисов):
                            </p>
                            <p className={`polzovatelskoe-soglashenie__item`}>
                                &mdash;&nbsp;доступ к&nbsp;электронному контенту на&nbsp;бесплатной основе,
                                с&nbsp;правом просмотра контента;
                            </p>
                            <p className={`polzovatelskoe-soglashenie__item`}>
                                &mdash;&nbsp;доступ к&nbsp;средствам поиска и&nbsp;навигации Интернет-ресурса;
                            </p>
                            <p className={`polzovatelskoe-soglashenie__item`}>
                                &mdash;&nbsp;предоставление Пользователю возможности размещения сообщений,
                                комментариев, рецензий Пользователей, выставления оценок контенту;
                            </p>
                            <p className={`polzovatelskoe-soglashenie__item`}>
                                &mdash;&nbsp;доступ к&nbsp;информации о&nbsp;Товаре и&nbsp;к&nbsp;информации
                                о&nbsp;порядке его приобретения и&nbsp;доставки на&nbsp;платной основе;
                            </p>
                            <p className={`polzovatelskoe-soglashenie__item`}>
                                &mdash;&nbsp;иные виды услуг (сервисов), реализуемые на&nbsp;страницах Сайта.
                            </p>
                            <p className={`polzovatelskoe-soglashenie__item`}>
                                3.3. Под действие настоящего Соглашения подпадают все существующие (реально
                                функционирующие) на&nbsp;данный момент услуги (сервисы) Сайта, а&nbsp;также
                                любые их&nbsp;последующие модификации и&nbsp;появляющиеся в&nbsp;дальнейшем
                                дополнительные услуги (сервисы).
                            </p>
                            <p className={`polzovatelskoe-soglashenie__item`}>
                                3.4. Доступ к&nbsp;Интернет-ресурсам предоставляется на&nbsp;бесплатной основе.
                            </p>
                            <p className={`polzovatelskoe-soglashenie__item`}>
                                3.5. Настоящее Соглашение является публичной офертой. Получая доступ
                                к&nbsp;Сайту Пользователь считается присоединившимся к&nbsp;настоящему
                                Соглашению.
                            </p>
                            <p className={`polzovatelskoe-soglashenie__item`}>
                                3.6. Использование материалов и&nbsp;сервисов Сайта регулируется нормами
                                действующего законодательства Российской Федерации.
                            </p>
                        </div>
                        <div className={`polzovatelskoe-soglashenie__section`}>
                            <p className={`polzovatelskoe-soglashenie__title`}>
                                4. Права и&nbsp;обязанности сторон
                            </p>
                            <p className={`polzovatelskoe-soglashenie__item`}>
                                4.1. Администрация сайта вправе:
                            </p>
                            <p className={`polzovatelskoe-soglashenie__item`}>
                                4.1.1. изменять правила пользования Сайтом, а&nbsp;также изменять содержание
                                данного Сайта. Изменения вступают в&nbsp;силу с&nbsp;момента публикации новой
                                редакции Соглашения на&nbsp;Сайте. При несогласии Пользователя с&nbsp;внесенными
                                изменениями он&nbsp;обязан отказаться от&nbsp;доступа к&nbsp;Сайту, прекратить
                                использование материалов и&nbsp;сервисов Сайта;
                            </p>
                            <p className={`polzovatelskoe-soglashenie__item`}>
                                4.1.2. ограничить доступ к&nbsp;Сайту в&nbsp;случае нарушения Пользователем
                                условий настоящего Соглашения.
                            </p>
                            <p className={`polzovatelskoe-soglashenie__item`}>
                                4.2. Пользователь вправе:
                            </p>
                            <p className={`polzovatelskoe-soglashenie__item`}>
                                4.2.1. получить доступ к&nbsp;использованию Сайта после соблюдения требований
                                о&nbsp;регистрации;
                            </p>
                            <p className={`polzovatelskoe-soglashenie__item`}>
                                4.2.2. пользоваться всеми имеющимися на&nbsp;Сайте услугами, а&nbsp;также
                                просматривать и&nbsp;приобретать Товары, представленные для ознакомления
                                на&nbsp;Сайте;
                            </p>
                            <p className={`polzovatelskoe-soglashenie__item`}>
                                4.2.3. задавать любые вопросы, относящиеся к&nbsp;деятельности Сайта
                                по&nbsp;реквизитам, которые находятся в&nbsp;разделе &laquo;Контакты&raquo;;
                            </p>
                            <p className={`polzovatelskoe-soglashenie__item`}>
                                4.2.4. пользоваться Сайтом исключительно в&nbsp;целях и&nbsp;порядке,
                                предусмотренных Соглашением и&nbsp;не&nbsp;запрещенных законодательством
                                Российской Федерации.
                            </p>
                            <p className={`polzovatelskoe-soglashenie__item`}>
                                4.3. Пользователь Сайта обязуется:
                            </p>
                            <p className={`polzovatelskoe-soglashenie__item`}>
                                4.3.1. предоставлять по&nbsp;запросу Администрации сайта дополнительную
                                информацию, которая имеет непосредственное отношение к&nbsp;предоставляемым
                                услугам данного Сайта;
                            </p>
                            <p className={`polzovatelskoe-soglashenie__item`}>
                                4.3.2. соблюдать имущественные и&nbsp;неимущественные права авторов и&nbsp;иных
                                правообладателей при использовании Сайта;
                            </p>
                            <p className={`polzovatelskoe-soglashenie__item`}>
                                4.3.3. не&nbsp;предпринимать действий, которые могут рассматриваться как
                                нарушающие нормальную работу Сайта;
                            </p>
                            <p className={`polzovatelskoe-soglashenie__item`}>
                                4.3.4. не&nbsp;распространять с&nbsp;использованием Сайта любую конфиденциальную
                                и&nbsp;охраняемую законодательством Российской Федерации информацию
                                о&nbsp;физических либо юридических лицах;
                            </p>
                            <p className={`polzovatelskoe-soglashenie__item`}>
                                4.3.5. избегать любых действий, в&nbsp;результате которых может быть нарушена
                                конфиденциальность охраняемой законодательством Российской Федерации информации;
                            </p>
                            <p className={`polzovatelskoe-soglashenie__item`}>
                                4.3.6. не&nbsp;использовать Сайт для распространения информации рекламного
                                характера, иначе как с&nbsp;согласия Администрации сайта;
                            </p>
                            <p className={`polzovatelskoe-soglashenie__item`}>
                                4.3.7. Не&nbsp;использовать сервисы Сайта с&nbsp;целью:
                            </p>
                            <p className={`polzovatelskoe-soglashenie__item`}>
                                4.3.7.1. загрузки контента, который является незаконным, нарушает любые права
                                третьих лиц; пропагандирует насилие, жестокость, ненависть&nbsp;и (или)
                                дискриминацию по&nbsp;расовому, национальному, половому, религиозному,
                                социальному признакам; содержит недостоверные сведения&nbsp;и (или) оскорбления
                                в&nbsp;адрес конкретных лиц, организаций, органов власти;
                            </p>
                            <p className={`polzovatelskoe-soglashenie__item`}>
                                4.3.7.2. побуждения к&nbsp;совершению противоправных действий, а&nbsp;также
                                содействия лицам, действия которых направлены на&nbsp;нарушение ограничений
                                и&nbsp;запретов, действующих на&nbsp;территории Российской Федерации;
                            </p>
                            <p className={`polzovatelskoe-soglashenie__item`}>
                                4.3.7.3. нарушения прав несовершеннолетних лиц&nbsp;и (или) причинение
                                им&nbsp;вреда в&nbsp;любой форме;
                            </p>
                            <p className={`polzovatelskoe-soglashenie__item`}>
                                4.3.7.4. ущемления прав меньшинств;
                            </p>
                            <p className={`polzovatelskoe-soglashenie__item`}>
                                4.3.7.5. представления себя за&nbsp;другого человека или представителя
                                организации&nbsp;и (или) сообщества без достаточных на&nbsp;то&nbsp;прав,
                                в&nbsp;том числе за&nbsp;сотрудников данного Интернет-ресурса;
                            </p>
                            <p className={`polzovatelskoe-soglashenie__item`}>
                                4.3.7.6. введения в&nbsp;заблуждение относительно свойств и&nbsp;характеристик
                                какого-либо Товара из&nbsp;каталога, размещенного на&nbsp;Сайте;
                            </p>
                            <p className={`polzovatelskoe-soglashenie__item`}>
                                4.3.7.7. некорректного сравнения Товара, а&nbsp;также формирования негативного
                                отношения к&nbsp;лицам, (не) пользующимся определенными Товарами, или осуждения
                                таких лиц.
                            </p>
                            <p className={`polzovatelskoe-soglashenie__item`}>
                                4.4. Пользователю запрещается:
                            </p>
                            <p className={`polzovatelskoe-soglashenie__item`}>
                                4.4.1. использовать любые устройства, программы, процедуры, алгоритмы
                                и&nbsp;методы, автоматические устройства или эквивалентные ручные процессы для
                                доступа, приобретения, копирования или отслеживания содержания данного Сайта;
                            </p>
                            <p className={`polzovatelskoe-soglashenie__item`}>
                                4.4.2. нарушать надлежащее функционирование Сайта;
                            </p>
                            <p className={`polzovatelskoe-soglashenie__item`}>
                                4.4.3. обходить любым способом навигационную структуру Сайта для получения или
                                попытки получения любой информации, документов или материалов любыми средствами,
                                которые специально не&nbsp;представлены сервисами данного Сайта;
                            </p>
                            <p className={`polzovatelskoe-soglashenie__item`}>
                                4.4.4. несанкционированный доступ к&nbsp;функциям Сайта, любым другим системам
                                или сетям, относящимся к&nbsp;данному Сайту, а&nbsp;также к&nbsp;любым услугам,
                                предлагаемым на&nbsp;Сайте;
                            </p>
                            <p className={`polzovatelskoe-soglashenie__item`}>
                                4.4.5. нарушать систему безопасности или аутентификации на&nbsp;Сайте или
                                в&nbsp;любой сети, относящейся к&nbsp;Сайту;
                            </p>
                            <p className={`polzovatelskoe-soglashenie__item`}>
                                4.4.6. выполнять обратный поиск, отслеживать или пытаться отслеживать любую
                                информацию о&nbsp;любом другом Пользователе Сайта;
                            </p>
                            <p className={`polzovatelskoe-soglashenie__item`}>
                                4.4.7. использовать Сайт и&nbsp;его Содержание в&nbsp;любых целях, запрещенных
                                законодательством Российской Федерации, а&nbsp;также подстрекать к&nbsp;любой
                                незаконной деятельности или другой деятельности, нарушающей права Компании,
                                ее&nbsp;партнеров или других лиц.
                            </p>
                        </div>
                        <div className={`polzovatelskoe-soglashenie__section`}>
                            <p className={`polzovatelskoe-soglashenie__title`}>
                                5. Использование сайта
                            </p>
                            <p className={`polzovatelskoe-soglashenie__item`}>
                                5.1. Сайт и&nbsp;Содержание, входящее в&nbsp;состав Сайта, принадлежит
                                и&nbsp;управляется Администрацией сайта.
                            </p>
                            <p className={`polzovatelskoe-soglashenie__item`}>
                                5.2. Содержание Сайта не&nbsp;может быть скопировано, опубликовано,
                                воспроизведено, передано или распространено любым способом, а&nbsp;также
                                размещено в&nbsp;глобальной сети &laquo;Интернет&raquo; без предварительного
                                письменного согласия Администрации сайта.
                            </p>
                            <p className={`polzovatelskoe-soglashenie__item`}>
                                5.3. Содержание Сайта защищено авторским правом, законодательством
                                о&nbsp;товарных знаках, а&nbsp;также другими правами, связанными
                                с&nbsp;интеллектуальной собственностью, и&nbsp;законодательством
                                о&nbsp;недобросовестной конкуренции.
                            </p>
                            <p className={`polzovatelskoe-soglashenie__item`}>
                                5.4. Поиск и&nbsp;приобретение Товаров, представленных на&nbsp;Сайте, может
                                потребовать создания учётной записи Пользователя.
                            </p>
                            <p className={`polzovatelskoe-soglashenie__item`}>
                                5.5. Пользователь несет персональную ответственность за&nbsp;сохранение
                                конфиденциальности информации учётной записи, включая пароль, а&nbsp;также
                                за&nbsp;всю без исключения деятельность, которая ведётся от&nbsp;имени
                                Пользователя учётной записи.
                            </p>
                            <p className={`polzovatelskoe-soglashenie__item`}>
                                5.6. Пользователь должен незамедлительно уведомить Администрацию сайта
                                о&nbsp;несанкционированном использовании его учётной записи или пароля или любом
                                другом нарушении системы безопасности.
                            </p>
                            <p className={`polzovatelskoe-soglashenie__item`}>
                                5.7. Администрация сайта обладает правом в&nbsp;одностороннем порядке
                                аннулировать учетную запись Пользователя, если она не&nbsp;использовалась более
                                12&nbsp;календарных месяцев подряд без уведомления Пользователя.
                            </p>
                            <p className={`polzovatelskoe-soglashenie__item`}>
                                5.8. Настоящее Соглашение распространяет свое действия на&nbsp;все
                                дополнительные положения и&nbsp;условия о&nbsp;приобретении Товаров
                                и&nbsp;оказанию услуг, предоставляемых на&nbsp;Сайте.
                            </p>
                            <p className={`polzovatelskoe-soglashenie__item`}>
                                5.9. Информация, размещаемая на&nbsp;Сайте не&nbsp;должна истолковываться как
                                изменение настоящего Соглашения.
                            </p>
                            <p className={`polzovatelskoe-soglashenie__item`}>
                                5.10. Администрация сайта имеет право в&nbsp;любое время без уведомления
                                Пользователя вносить изменения в&nbsp;перечень Товаров и&nbsp;услуг,
                                представленных на&nbsp;Сайте, и&nbsp;(или) в&nbsp;цены, применимые к&nbsp;таким
                                Товарам.
                            </p>
                            <p className={`polzovatelskoe-soglashenie__item`}>
                                5.11. Документы, указанные в&nbsp;пунктах 5.11.1&nbsp;&mdash; 5.11.3 настоящего
                                Соглашения, регулируют в&nbsp;соответствующей части и&nbsp;распространяют свое
                                действие на&nbsp;использование Пользователем Сайта. В&nbsp;настоящее Соглашение
                                включены следующие документы:
                            </p>
                            <p className={`polzovatelskoe-soglashenie__item`}>
                                5.11.1.
                                <Link href={`/politika-konfidencialnosti`}
                                          className={`link link__bold link__pdf`}>
                                    &nbsp;Политика конфиденциальности
                                </Link>;
                            </p>
                            <p className={`polzovatelskoe-soglashenie__item`}>
                                5.11.2. Пользовательское Соглашение;
                            </p>
                            <p className={`polzovatelskoe-soglashenie__item`}>
                                5.11.3.
                                <Link href={`/rule/dogovor-publichnoj-oferty`}
                                          className={`link link__bold link__pdf`}>
                                    &nbsp;Договор публичной оферты
                                </Link>.
                                {/*<a href="/storage/docs/dogovor_publichnoy_oferti.pdf"*/}
                                {/*   className={`link link__bold link__pdf`}*/}
                                {/*   target={`_blank`}>*/}
                                {/*    &nbsp;Договор публичной оферты*/}
                                {/*</a>.*/}
                            </p>
                            <p className={`polzovatelskoe-soglashenie__item`}>
                                5.12. Любой из&nbsp;документов, перечисленных в&nbsp;пункте 5.11. настоящего
                                Соглашения может подлежать обновлению. Изменения вступают в&nbsp;силу
                                с&nbsp;момента их&nbsp;опубликования на&nbsp;Сайте.
                            </p>
                            <p className={`polzovatelskoe-soglashenie__item`}>
                                5.13. Покупатель для регистрации Личного кабинета заполняет Анкету регистрации
                                на&nbsp;сайте platina-jewelry.ru. Заполняя анкету регистрации, Пользователь должен
                                ввести свои фамилию, имя, отчество, актуальную информацию о&nbsp;принадлежащем ему
                                номере телефона, паспортных данных, адресе электронной почты, принадлежащих
                                непосредственно Покупателю. После заполнения Анкеты регистрации Пользователь
                                в&nbsp;электронной форме направляет её&nbsp;Администрации Сайта.
                            </p>
                            <p className={`polzovatelskoe-soglashenie__item`}>
                                5.14. После получения Анкеты регистрации от&nbsp;Пользователя Администрацией Сайта
                                по&nbsp;адресу электронной почты и/или по&nbsp;номеру телефона, указанным Пользователем
                                в&nbsp;Анкете, в&nbsp;автоматическом режиме направляется электронное письмо
                                со&nbsp;ссылкой или уникальный авторизационный пароль (цифровой, буквенный или
                                смешанный). Введение Пользователем полученного от&nbsp;Администрации Сайта пароля
                                означает окончание регистрации Личного кабинета Пользователя.
                            </p>
                        </div>
                        <div className={`polzovatelskoe-soglashenie__section`}>
                            <p className={`polzovatelskoe-soglashenie__title`}>
                                6. Ответственность
                            </p>
                            <p className={`polzovatelskoe-soglashenie__item`}>
                                6.1. Любые убытки, которые Пользователь может понести в&nbsp;случае умышленного
                                или неосторожного нарушения любого положения настоящего Соглашения, а&nbsp;также
                                вследствие несанкционированного доступа к&nbsp;коммуникациям другого
                                Пользователя, Администрацией сайта не&nbsp;возмещаются.
                            </p>
                            <p className={`polzovatelskoe-soglashenie__item`}>
                                6.2. Администрация сайта не&nbsp;несет ответственности&nbsp;за:
                            </p>
                            <p className={`polzovatelskoe-soglashenie__item`}>
                                6.2.1. задержки или сбои в&nbsp;процессе совершения операции, возникшие
                                вследствие непреодолимой силы, а&nbsp;также любого случая неполадок
                                в&nbsp;телекоммуникационных, компьютерных, электрических и&nbsp;иных смежных
                                системах;
                            </p>
                            <p className={`polzovatelskoe-soglashenie__item`}>
                                6.2.2. ненадлежащее функционирование Сайта, в&nbsp;случае, если Пользователь
                                не&nbsp;имеет необходимых технических средств для его использования,
                                а&nbsp;также не&nbsp;несет никаких обязательств по&nbsp;обеспечению
                                пользователей такими средствами;
                            </p>
                            <p className={`polzovatelskoe-soglashenie__item`}>
                                6.2.3. посещение и&nbsp;использование Пользователем внешних ресурсов, ссылки
                                на&nbsp;которые могут содержаться на&nbsp;Сайте.
                            </p>
                            <p className={`polzovatelskoe-soglashenie__item`}>
                                6.3. Администрация Сайта не&nbsp;несет ответственности и&nbsp;не&nbsp;имеет
                                прямых или косвенных обязательств перед Пользователем в&nbsp;связи с&nbsp;любыми
                                возможными или возникшими потерями или убытками, связанными с&nbsp;любым
                                содержанием Сайта, регистрацией авторских прав и&nbsp;сведениями о&nbsp;такой
                                регистрации, товарами или услугами, доступными на&nbsp;или полученными через
                                внешние сайты или ресурсы либо иные контакты Пользователя, в&nbsp;которые
                                он&nbsp;вступил, используя размещенную на&nbsp;Сайте информацию или ссылки
                                на&nbsp;внешние ресурсы.
                            </p>
                            <p className={`polzovatelskoe-soglashenie__item`}>
                                6.4. Пользователь согласен с&nbsp;тем, что Администрация Сайта не&nbsp;несет
                                какой-либо ответственности и&nbsp;не&nbsp;имеет каких-либо обязательств
                                в&nbsp;связи с&nbsp;рекламой, которая может быть размещена на&nbsp;Сайте.
                            </p>
                            <p className={`polzovatelskoe-soglashenie__item`}>
                                6.5. За&nbsp;незаконное копирование, использование Содержания Сайта,
                                правообладателем которого является Общество с&nbsp;ограниченной ответственностью
                                Ювелирный завод &laquo;Платина&raquo;, Пользователь Сайта обязан выплатить
                                правообладателю компенсацию в&nbsp;размере от&nbsp;10&nbsp;тысяч
                                до&nbsp;5&nbsp;миллионов рублей на&nbsp;основании претензии правообладателя, либо
                                в&nbsp;ином размере, определяемом в&nbsp;соответствии со&nbsp;статьей 1301
                                Гражданского кодекса Российской Федерации.
                            </p>
                            <p className={`polzovatelskoe-soglashenie__item`}>
                                6.6. За&nbsp;каждый факт незаконного использования Пользователем Сайта дизайнов
                                ювелирных изделий, фирменного наименования владельца Сайта&nbsp;&mdash; Общества
                                с&nbsp;ограниченной ответственностью Ювелирный завод &laquo;Платина&raquo;,
                                коммерческих обозначений &laquo;Ювелирный
                                бренд &laquo;Платина&raquo;, &laquo;Ювелирный
                                завод &laquo;Платина&raquo;, &laquo;PLATINA JEWELRY&raquo; их&nbsp;составных частей
                                Пользователь Сайта обязан уплатить в&nbsp;пользу ООО
                                ЮЗ&nbsp;&laquo;Платина&raquo; штраф в&nbsp;размере 200 тысяч рублей.
                            </p>
                            <p className={`polzovatelskoe-soglashenie__item`}>
                                6.7. За&nbsp;незаконное использование товарных знаков, правообладателем которых
                                является Общество с&nbsp;ограниченной ответственностью Ювелирный
                                завод &laquo;Платина&raquo;, Пользователь Сайта обязан выплатить правообладателю
                                компенсацию в&nbsp;размере от&nbsp;10&nbsp;тысяч до&nbsp;5&nbsp;миллионов рублей
                                на&nbsp;основании претензии правообладателя, либо в&nbsp;ином размере, определяемом
                                в&nbsp;соответствии с&nbsp;пунктом 4&nbsp;статьи 1515 Гражданского кодекса
                                Российской Федерации.
                            </p>
                        </div>
                        <div className={`polzovatelskoe-soglashenie__section`}>
                            <p className={`polzovatelskoe-soglashenie__title`}>
                                7. Нарушение условий пользовательского соглашения
                            </p>
                            <p className={`polzovatelskoe-soglashenie__item`}>
                                7.1. Администрация сайта вправе раскрыть любую собранную о&nbsp;Пользователе
                                данного Сайта информацию, если раскрытие необходимо в&nbsp;связи
                                с&nbsp;расследованием или жалобой в&nbsp;отношении неправомерного использования
                                Сайта либо для установления (идентификации) Пользователя, который может нарушать
                                или вмешиваться в&nbsp;права Администрации сайта или в&nbsp;права других
                                Пользователей Сайта.
                            </p>
                            <p className={`polzovatelskoe-soglashenie__item`}>
                                7.2. Администрация Сайта имеет право раскрыть любую информацию о&nbsp;Пользователе,
                                которую посчитает необходимой для выполнения положений действующего законодательства
                                или судебных решений, обеспечения выполнения условий настоящего Соглашения, защиты
                                прав или безопасности ООО ЮЗ&nbsp;&laquo;Платина&raquo;, его партнеров
                                и&nbsp;Пользователей.
                            </p>
                            <p className={`polzovatelskoe-soglashenie__item`}>
                                7.3. Администрация сайта имеет право раскрыть информацию о&nbsp;Пользователе,
                                если действующее законодательство Российской Федерации требует или разрешает
                                такое раскрытие.
                            </p>
                            <p className={`polzovatelskoe-soglashenie__item`}>
                                7.4. Администрация сайта вправе без предварительного уведомления Пользователя
                                прекратить&nbsp;и (или) заблокировать доступ к&nbsp;Сайту, если Пользователь
                                нарушил настоящее Соглашение или содержащиеся в&nbsp;иных документах условия
                                пользования Сайтом, а&nbsp;также в&nbsp;случае прекращения действия Сайта либо
                                по&nbsp;причине технической неполадки или проблемы.
                            </p>
                            <p className={`polzovatelskoe-soglashenie__item`}>
                                7.5. Администрация сайта не&nbsp;несет ответственности перед Пользователем или
                                третьими лицами за&nbsp;прекращение доступа к&nbsp;Сайту в&nbsp;случае нарушения
                                Пользователем любого положения настоящего Соглашения или иного документа,
                                содержащего условия пользования Сайтом.
                            </p>
                        </div>
                        <div className={`polzovatelskoe-soglashenie__section`}>
                            <p className={`polzovatelskoe-soglashenie__title`}>
                                8. Разрешение споров
                            </p>
                            <p className={`polzovatelskoe-soglashenie__item`}>
                                8.1. В&nbsp;случае возникновения любых разногласий или споров между Сторонами
                                настоящего Соглашения обязательным условием до&nbsp;обращения в&nbsp;суд
                                является предъявление претензии (письменного предложения о&nbsp;добровольном
                                урегулировании спора).
                            </p>
                            <p className={`polzovatelskoe-soglashenie__item`}>
                                8.2. Получатель претензии в&nbsp;течение 30&nbsp;календарных дней со&nbsp;дня
                                ее&nbsp;получения, письменно уведомляет заявителя претензии о&nbsp;результатах
                                рассмотрения претензии.
                            </p>
                            <p className={`polzovatelskoe-soglashenie__item`}>
                                8.3. При невозможности разрешить спор в&nbsp;добровольном порядке любая
                                из&nbsp;сторон вправе обратиться в&nbsp;суд за&nbsp;защитой своих прав, которые
                                предоставлены им&nbsp;действующим законодательством Российской Федерации. При этом
                                Пользователь выражает свое полное и&nbsp;безоговорочное согласие с&nbsp;тем, что все
                                споры, возникающие между Администрацией сайта и&nbsp;Пользователем, который является
                                юридическим лицом или индивидуальным предпринимателем, подлежат рассмотрению
                                в&nbsp;Арбитражном суде Костромской области.
                            </p>
                            <p className={`polzovatelskoe-soglashenie__item`}>
                                8.4. Любой иск в&nbsp;отношении условий использования Сайта должен быть
                                предъявлен в&nbsp;течение 3&nbsp;лет после возникновения оснований для иска,
                                за&nbsp;исключением защиты авторских прав на&nbsp;охраняемые в&nbsp;соответствии
                                с&nbsp;законодательством материалы Сайта. При нарушении условий данного пункта
                                любой иск или основания для иска погашаются исковой давностью.
                            </p>
                            <p className={`polzovatelskoe-soglashenie__item`}>
                                8.5. Применимым правом к&nbsp;правоотношениям, возникающим при исполнении Сторонами
                                настоящего Соглашения, является право Российской Федерации.
                            </p>
                        </div>
                        <div className={`polzovatelskoe-soglashenie__section`}>
                            <p className={`polzovatelskoe-soglashenie__title`}>
                                9. Дополнительные условия
                            </p>
                            <p className={`polzovatelskoe-soglashenie__item`}>
                                9.1. Администрация сайта не&nbsp;принимает встречные предложения
                                от&nbsp;Пользователя относительно изменений настоящего Пользовательского
                                Соглашения.
                            </p>
                            <p className={`polzovatelskoe-soglashenie__item`}>
                                9.2. Отзывы Пользователя, размещенные на&nbsp;Сайте, не&nbsp;являются
                                конфиденциальной информацией и&nbsp;могут быть использованы Администрацией сайта
                                без ограничений.
                            </p>
                        </div>
                    </div>
                </div>
            </section>
        </BaseLayout>
    }
}

export default useWithStore(PolzovatelskoeSoglashenie);


